import axios from "axios";
import { IP } from "../index.js";
/* ai */
export async function ai_api(data) {
  var resp = await axios.post(`${IP}/admin/ai/create`, data);
  return resp.data;
}


/* 查询 */
export async function selectApi(data) {
  var resp = await axios.post(`${IP}/admin/ai/select`, data);
  return resp.data;
}

/* 新增 */
export async function addApi(data) {
  var resp = await axios.post(`${IP}/admin/ai/add`, data);
  return resp.data;
}
